import Bus from './bus'
import { constant } from 'lodash'

const busReflectHandler = {
  apply: function (target, thisarg, args) {
    Reflect.apply(target, Bus, args)

    return thisarg
  },
  set: constant(true)
}

export class ExtensionsManager {
  constructor () {
    this.on = new Proxy(Bus.on, busReflectHandler)
    this.once = new Proxy(Bus.once, busReflectHandler)
    this.off = new Proxy(Bus.off, busReflectHandler)
  }
}
